import React from 'react';
import _ from 'lodash';
import classnames from 'classnames';
import Checkbox from 'app/components/general/Checkbox';
import CardGroup from 'app/components/general/CardGroup';
import { Card, CardBody, Collapse } from 'reactstrap';

interface IPriceSummaryProps {
  selected: boolean;
  title: string;
  size: string;
  description: string;
  extraText: string;
  totalAmount: string;
  totalAmountYearly: string;
  handleSelect: Function;
  lineItems: {
    amount: string;
    name: string;
  }[];
}
export default class PriceSummary extends React.Component<IPriceSummaryProps> {
  static defaultProps: IPriceSummaryProps = {
    selected: false,
    title: 'Price Summary',
    description: '',
    price: '',
    handleSelect: undefined,
  };

  renderLineItem = (lineItems): React.ReactNode => _.map(lineItems, (li) => (
    <div className="price-line-item">
      <div className="row">
        <div className="col text-weight-medium">
          {li.name}
          {' '}
          x
          {' '}
          {this.props.size}
        </div>
        <div className="col text-weight-medium-bold text-right">
          {li.amount}
          {' '}
          / month
        </div>
      </div>
    </div>
  ))

  renderLineItems = (): React.ReactNode => (
    <div>
      {this.renderLineItem([this.props.lineItems[0]])}
    </div>
  )

  render(): React.ReactNode {
    const plan = this.props.lineItems[0];
    return (
      <div
        className="price-summary"
      >
        <div className="row">
          <div className="col">
            <CardGroup className="no-shadow-3" title={this.props.title} isOpen>
              <div className="row">
                <div className="col text-center medium-text text-capitalize">
                  {plan.name}
                </div>
              </div>
              <div className="row margin-top">
                <div className="col text-center large-text text-weight-bold">
                  {this.props.totalAmount}
                  {' '}
                  / month
                </div>
              </div>
              <div className="row margin-top">
                <div className="col">
                  {this.renderLineItems()}
                </div>
              </div>
              <div className="row with-margin-top">
                <div className="col">
                  All prices are
                  {' '}
                  <span className="text-weight-medium-bold">AUD</span>
                  {' '}
                  and excluding
                  {' '}
                  <span className="text-weight-medium-bold">GST</span>
                  .
                </div>
              </div>
            </CardGroup>

          </div>
        </div>
      </div>
    );
  }
}
